@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Texas</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      @if (controls?.length >= 1) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
              >
                Please select an option.
              </span>
            }
          }
        </div>
      }

      <div class="axis-grid">
        @if (
          (baseRules["Select_Aggregate_Total_Limits_DropDown"]?.includes("show") ||
            baseRules["Select_Aggregate_Total_Limits_DropDown"]?.includes("form")) &&
          ((baseRules["selectionId"] !== "AcceptCoverage_RejectAdditionalPIP_VaryByState") && 
          (baseRules["selectionId"] !== "AcceptCoverage_AcceptAdditionalPIP_VaryByState") &&
          (baseRules["selectionId"] !== "AcceptCoverage_VaryByState_VaryByState")
        )) {
          <div class="axis-col-sm-6 axis-col-md-6">
            <div
              class="axis-form-group _mt-medium"
              [ngClass]="{
                'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
                'has-axis-error':
                  reactiveForm.get(controls[1].formControlName)?.touched &&
                  reactiveForm.get(controls[1].formControlName)?.invalid,
              }"
            >
              <label
                class="axis-control-label"
                for="{{ controls[1].formControlName }}"
                >{{ controls[1].label }}
                <span
                  aria-hidden="true"
                  class="axis-required-indicator"
                  >*</span
                >
              </label>
              <axis-dropdown
                [dataProvider]="controls[1].data"
                id="{{ controls[1].formControlName }}"
                formControlName="{{ controls[1].formControlName }}"
              ></axis-dropdown>
              @if (reactiveForm.get(controls[1].formControlName)?.touched) {
                @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                  <span
                    class="axis-error-block"
                    role="alert"
                  >
                    Please select the {{ controls[1].label }}
                  </span>
                }
              }
            </div>
          </div>
        }
        @if (
          (baseRules["Select_Aggregate_Total_Limits_DropDown"]?.includes("show") ||
            baseRules["Select_Aggregate_Total_Limits_DropDown"]?.includes("form")) &&
          ((baseRules["selectionId"] === "AcceptCoverage_RejectAdditionalPIP_VaryByState") || 
          (baseRules["selectionId"] === "AcceptCoverage_AcceptAdditionalPIP_VaryByState") ||
          (baseRules["selectionId"] === "AcceptCoverage_VaryByState_VaryByState")
        )) {
          <div class="axis-col-sm-6 axis-col-md-6">
            <div
              class="axis-form-group _mt-medium"
              [ngClass]="{
                'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
                'has-axis-error':
                  reactiveForm.get(controls[1].formControlName)?.touched &&
                  reactiveForm.get(controls[1].formControlName)?.invalid,
              }"
            >
              <label
                class="axis-control-label"
                for="{{ textValues?.Select_Aggregate_Total_Limits_Dropdown_Text }}"
                >{{ textValues?.Select_Aggregate_Total_Limits_Dropdown_Text }}</label
              >
              <axis-dropdown
                [dataProvider]="controls[1].data"
                id="{{ controls[1].formControlName }}"
                formControlName="{{ controls[1].formControlName }}"
                (onSelect)="onSelect(baseRules['selectionId'], controls[1].formControlName)"
              ></axis-dropdown>
              @if (reactiveForm.get(controls[1].formControlName)?.touched) {
                @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                  <span
                    class="axis-error-block"
                    role="alert"
                    >Please select an option.</span
                  >
                }
              }
            </div>
          </div>
        }
      </div>
    </form>
  }
}

@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Texas</h2>
  @if (baseRules?.Reject_LevelOne_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text }}
      </label>
    </div>
  }
  @if (baseRules?.Select_LevelOne_Radio) {
    @if (baseRules?.Fixed_Aggregate_Total_Limits_2500_DropDown) {
      <div class="axis-form-group">
        <label class="axis-control-label"> {{ controls[2].label }} </label>
        <div>{{ controls[2].data[0].name }}</div>
      </div>
    }
    @if (baseRules?.Fixed_Aggregate_Total_Limits_100000_DropDown) {
      <div class="axis-form-group">
        <label class="axis-control-label"> {{ controls[3].label }} </label>
        <div>{{ controls[3].data[0].name }}</div>
      </div>
    }
  }
}
